import type { Insight } from "../types/content";

export const insights: Insight[] = [
  {
    slug: "moldova-energy-resilience-agri-food",
    title: {
      en: "Moldova Energy Resilience for Agri-Food",
      ro: "Rezilienta energetica pentru agroalimentar in Moldova",
      he: "חוסן אנרגטי לתעשיית המזון והחקלאות במולדובה"
    },
    subtitle: {
      en: "A forthcoming brief on practical energy constraints in processing, cold storage and wineries.",
      ro: "Un brief in pregatire despre constrangeri energetice in procesare, depozitare frigorifica si vinarii.",
      he: "מסמך בהכנה על מגבלות אנרגיה מעשיות בעיבוד, קירור ויקבים."
    },
    category: "Energy",
    date: null,
    status: "forthcoming",
    author: null,
    readingTime: 6,
    coverStyle: "energy",
    body: {
      en: ["This publication is being prepared. It will be published after review and source validation."],
      ro: ["Aceasta publicatie este in pregatire. Va fi publicata dupa revizuire si validarea surselor."],
      he: ["הפרסום נמצא בהכנה. הוא יפורסם לאחר בדיקה ואימות מקורות."]
    }
  },
  {
    slug: "israeli-climate-tech-opportunities-moldova",
    title: {
      en: "Israeli Climate-Tech Opportunities in Moldova",
      ro: "Oportunitati climate-tech israeliene in Moldova",
      he: "הזדמנויות אקלים-טק ישראליות במולדובה"
    },
    subtitle: {
      en: "A forthcoming market-fit note for technologies seeking credible pilots.",
      ro: "O nota in pregatire despre potrivirea de piata pentru tehnologii care cauta pilotari credibile.",
      he: "מסמך התאמת שוק בהכנה לטכנולוגיות המחפשות פיילוטים אמינים."
    },
    category: "Market fit",
    date: null,
    status: "forthcoming",
    author: null,
    readingTime: 5,
    coverStyle: "institutional",
    body: {
      en: ["This publication is being prepared. It does not announce partnerships or guaranteed introductions."],
      ro: ["Aceasta publicatie este in pregatire. Nu anunta parteneriate sau introduceri garantate."],
      he: ["הפרסום נמצא בהכנה. הוא אינו מכריז על שותפויות או היכרויות מובטחות."]
    }
  },
  {
    slug: "green-wine-energy-water-climate",
    title: {
      en: "Green Wine Moldova: Energy, Water & Climate",
      ro: "Green Wine Moldova: energie, apa si clima",
      he: "Green Wine Moldova: אנרגיה, מים ואקלים"
    },
    subtitle: {
      en: "A forthcoming editorial view of the vineyard-to-bottle sustainability pathway.",
      ro: "O perspectiva editoriala in pregatire despre traseul sustenabilitatii de la vie la sticla.",
      he: "מבט עריכתי בהכנה על מסלול הקיימות מהכרם ועד הבקבוק."
    },
    category: "Green Wine",
    date: null,
    status: "forthcoming",
    author: null,
    readingTime: 7,
    coverStyle: "wine",
    body: {
      en: ["This publication is being prepared as part of the Green Wine Moldova knowledge track."],
      ro: ["Aceasta publicatie este in pregatire in cadrul directiei de cunoastere Green Wine Moldova."],
      he: ["הפרסום נמצא בהכנה כחלק ממסלול הידע של Green Wine Moldova."]
    }
  }
];
